
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconTowerDanger as ObiBeaconTowerDangerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-tower-danger.js';
 
 
 

 
 export const ObiBeaconTowerDanger = createComponent({
   react: React,
   tagName: 'obi-beacon-tower-danger',
   elementClass: ObiBeaconTowerDangerElement,
   events: {
     
   }
  });
 
 